module.exports = __webpack_public_path__ + "img/pause.0ee6f584.svg";